import { Main, Page } from '../../src/components/Layout';
import React, { PureComponent } from 'react';

import Head from 'next/head';
import Header from '../../src/components/Header';
import Offers from './Offers';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import ShopList from './list';
import createContext from '../../src/utils/format/createContext';
import formatShops from '../../src/utils/collection/formatShops';
import getPageByType from '../../src/apollo/graphql/page/getPageByType';
import getShops from '../../src/apollo/graphql/shop/getShops';
import { withI18N } from '../../src/hoc/index';

class Brands extends PureComponent {
  state = {
    filters: {}
  };

  static async getInitialProps({ query, i18n }) {
    return {
      type: query && query.type,
      category: query && query.category,
      i18n
    };
  }

  renderList = () => (
    <Query
      query={getShops}
      variables={{
        orderBy: 'isNew_DESC'
      }}
      context={createContext(this.props.i18n.language)}
    >
      {({ loading, error, data }) => {
        if (!loading && !error && data.getShops) {
          const shops = formatShops(data.getShops);
          const { type, category } = this.props;
          return (
            <ShopList
              handleUpdateFilters={this.updateFilters}
              shops={Object.values(shops)}
              type={type}
              category={category}
              {...this.props}
            />
          );
        }
        return null;
      }}
    </Query>
  );

  renderOffers = () => {
    const { type, category } = this.props;
    const { filters } = this.state;
    return <Offers type={type} category={category} filters={filters} />;
  };

  updateFilters = filters => {
    this.setState({ filters });
  };

  render() {
    const { t } = this.props;

    return (
      <Page brands>
        <Query
          query={getPageByType}
          variables={{ type: 'shop' }}
          context={createContext(this.props.i18n.language)}
        >
          {({ loading, error, data }) => {
            if (!loading && !error && data && data.getPageByType) {
              const page = data.getPageByType;
              return page ? (
                <div>
                  <Head>
                    <title key="title">Grand Hôtel-Dieu</title>
                  </Head>
                  {page.detail ? (
                    <Header
                      title={page.detail.title}
                      image={page.img_header_desktop}
                      imageMobile={page.img_header_mobile}
                      search={false}
                      functional
                    />
                  ) : null}
                  <Main>
                    {this.renderList()}
                    {this.renderOffers()}
                  </Main>
                </div>
              ) : null;
            }

            return null;
          }}
        </Query>
      </Page>
    );
  }
}

Brands.propTypes = {
  t: PropTypes.func
};

export default withI18N()(Brands);
